import React, { useState } from 'react';
import styled from 'styled-components';
import tokens from '../theme/tokens';

const ExpandToggle = styled.button`
  border:none;background:none;color:${p => p.theme.colors.primary};cursor:pointer;
  font-size:${p => p.theme.typography.sizes.xs};padding:4px 0;margin-bottom:8px;
`;
const Row = styled.div`
  border:1px solid ${p => p.theme.colors.border};border-radius:${p => p.theme.radius.md}px;margin-bottom:8px;overflow:hidden;
  ${p => p.$clickable && 'cursor:pointer;'}
  &:hover{background:${p => p.$clickable ? p.theme.colors.background : 'transparent'};}
`;
const RowHeader = styled.div`
  display:flex;align-items:center;padding:12px 16px;min-height:44px;gap:12px;
`;
const Name = styled.div`flex:0 0 120px;font-weight:${p => p.theme.typography.weights.medium};font-size:${p => p.theme.typography.sizes.sm};`;
const BarWrap = styled.div`flex:1;height:8px;background:${p => p.theme.colors.border};border-radius:${p => p.theme.radius.sm}px;overflow:hidden;`;
const BarFill = styled.div`
  height:100%;width:${p => p.$pct}%;background:${p => p.$color};
  border-radius:${p => p.theme.radius.sm}px;transition:width 0.3s ease;
`;
const Score = styled.div`flex:0 0 50px;text-align:right;font-weight:${p => p.theme.typography.weights.semibold};font-size:${p => p.theme.typography.sizes.sm};`;
const PassFail = styled.span`
  flex:0 0 40px;font-size:${p => p.theme.typography.sizes.xs};font-weight:${p => p.theme.typography.weights.semibold};
  color:${p => p.$pass ? '#2e7d32' : p.theme.colors.error.text};
`;
const Desc = styled.div`
  padding:0 16px 12px;font-size:${p => p.theme.typography.sizes.sm};color:${p => p.theme.colors.text.secondary};line-height:1.5;
`;

export default function KootaGrid({ items, expandable = true, showExpandAll = true, lang = 'en' }) {
  const [expanded, setExpanded] = useState(new Set());

  const toggle = (i) => setExpanded(prev => {
    const next = new Set(prev);
    next.has(i) ? next.delete(i) : next.add(i);
    return next;
  });
  const expandAll = () => setExpanded(new Set(items.map((_, i) => i)));
  const collapseAll = () => setExpanded(new Set());

  return (
    <div>
      {expandable && showExpandAll && (
        <ExpandToggle onClick={expanded.size === items.length ? collapseAll : expandAll}>
          {expanded.size === items.length ? 'Collapse all' : 'Expand all'}
        </ExpandToggle>
      )}
      {items.map((item, i) => {
        const pct = item.maxScore > 0 ? (item.score / item.maxScore) * 100 : 0;
        const barColor = item.color || (item.pass ? tokens.colors.bands.strong : tokens.colors.bands.challenging);
        const isExp = expanded.has(i);
        return (
          <Row key={i} $clickable={expandable}
               onClick={expandable ? () => toggle(i) : undefined}
               aria-expanded={expandable ? isExp : undefined}>
            <RowHeader>
              <Name>{lang === 'ta' && item.nameTa ? item.nameTa : item.name}</Name>
              <BarWrap><BarFill $pct={pct} $color={barColor} /></BarWrap>
              <Score>{item.score}/{item.maxScore}</Score>
              <PassFail $pass={item.pass}>{item.pass ? 'Pass' : 'Fail'}</PassFail>
            </RowHeader>
            {expandable && isExp && item.description && <Desc>{item.description}</Desc>}
          </Row>
        );
      })}
    </div>
  );
}
